import * as t from '../actionTypes';
import { LOAD_STATUS, SORT_ORDER } from 'modules/common/constants';
import { TARGETS_LIST_PAGE_SIZE } from '../constants';

const ACTION_HANDLERS = {
    [t.SET_TARGETS_LIST_ITEMS]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            items: action.payload
        }
    }),
    [t.APPEND_TARGETS_LIST_ITEMS]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            items: state.targetsList.items.concat(action.payload)
        }
    }),
    [t.SET_TARGETS_LIST_PAGE]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            page: action.payload
        }
    }),
    [t.SET_TARGETS_LIST_COUNT]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            totalCount: action.payload
        }
    }),
    [t.SET_TARGETS_LIST_SORT_COLUMN]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            sortBy: action.payload
        }
    }),
    [t.SET_TARGETS_LIST_SORT_ORDER]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            sortOrder: action.payload
        }
    }),
    [t.SET_TARGETS_LIST_LOAD_STATUS]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            loadStatus: action.payload
        }
    }),
    [t.SET_TARGETS_LIST_SEARCH_TEXT]: (state, action) => ({
        ...state,
        targetsList: {
            ...state.targetsList,
            searchBy: action.payload
        }
    }),
    [t.RESET_TARGETS_LIST]: (state) => ({
        ...state,
        targetsList: initialState.targetsList
    }),
    [t.SET_TARGET_MANIFEST]: (state, action) => ({
        ...state,
        common: {
            ...state.common,
            manifest: {
                ...state.common.manifest,
                object: action.payload
            }
        }
    }),
    [t.SET_TARGET_MANIFEST_LOAD_STATUS]: (state, action) => ({
        ...state,
        common: {
            ...state.common,
            manifest: {
                ...state.common.manifest,
                loadStatus: action.payload
            }
        }
    }),
    [t.RESET_TARGET_MANIFEST]: (state) => ({
        ...state,
        common: {
            ...state.common,
            manifest: initialState.common.manifest
        }
    }),
    [t.SET_TARGET_DETAILS_LOAD_STATUS]: (state, action) => ({
        ...state,
        targetDetails: {
            ...state.targetDetails,
            loadStatus: action.payload
        }
    }),
    [t.SET_TARGET_DETAILS_OPERATION_IN_PROGRESS]: (state, action) => ({
        ...state,
        targetDetails: {
            ...state.targetDetails,
            targetOperationInProgress: action.payload
        }
    }),
    [t.SET_TARGET_DETAILS]: (state, action) => ({
        ...state,
        targetDetails: {
            ...state.targetDetails,
            data: action.payload
        }
    }),
    [t.RESET_TARGET_DETAILS]: (state) => ({
        ...state,
        targetDetails: initialState.targetDetails
    }),
    [t.SET_TARGET_FORM_OPERATION_IN_PROGRESS]: (state, action) => ({
        ...state,
        targetForm: {
            ...state.targetForm,
            targetOperationInProgress: action.payload
        }
    }),
    [t.RESET_TARGET_FORM]: (state) => ({
        ...state,
        targetForm: initialState.targetForm
    })
};

export const initialState = {
    common: {
        manifest: {
            object: {},
            loadStatus: LOAD_STATUS.REQUIRED
        }
    },
    targetDetails: {
        loadStatus: LOAD_STATUS.REQUIRED,
        data: {},
        targetOperationInProgress: false
    },
    targetsList: {
        items: [],
        totalCount: 0,
        page: 0,
        pageSize: TARGETS_LIST_PAGE_SIZE,
        sortBy: 'name',
        sortOrder: SORT_ORDER.ASC,
        searchBy: '',
        loadStatus: LOAD_STATUS.REQUIRED
    },
    targetForm: {
        targetOperationInProgress: false
    }
};

export default (state = initialState, action) => {
    const handler = ACTION_HANDLERS[action.type];

    return handler ? handler(state, action) : state;
};
